// Centralized manifest for latest client-provided photography
// Paths correspond to files in 'src/assets/Images latest/'

// --- Contact Us Page (1 image) ---
import contactHeaderImg from "./Images latest/Contact Us Page/IMG20260608155530.webp";

// --- Home Page (8 images) ---
import home1 from "./Images latest/Home - Main Page/BAI00729.webp";
import home2 from "./Images latest/Home - Main Page/DSC_1773.webp";
import home3 from "./Images latest/Home - Main Page/DSC_1803.webp";
import home4 from "./Images latest/Home - Main Page/DSC_7243.webp";
import home5 from "./Images latest/Home - Main Page/DSC_7257.webp";
import home6 from "./Images latest/Home - Main Page/IMG_20260608_110844275_HDR.webp";
import home7 from "./Images latest/Home - Main Page/WhatsApp Image 2026-04-16 at 6.14.57 PM.webp";
import home8 from "./Images latest/Home - Main Page/WhatsApp Image 2026-04-16 at 6.14.58 PM (2).webp";

// --- About Us Page (8 images) ---
import about1 from "./Images latest/About Us page/BAI03240.webp";
import about2 from "./Images latest/About Us page/DSC_1782.webp";
import about3 from "./Images latest/About Us page/DSC_1837.webp";
import about4 from "./Images latest/About Us page/VKP_8403.webp";
import about5 from "./Images latest/About Us page/VKP_8434.webp";
import about6 from "./Images latest/About Us page/VKP_8458.webp";
import about7 from "./Images latest/About Us page/WhatsApp Image 2026-03-12 at 7.09.00 PM.webp";
import about8 from "./Images latest/About Us page/WhatsApp Image 2026-04-08 at 6.21.27 PM.webp";

// --- Our Work Page (46 images) ---
import workInitiativeKitchen from "./Images latest/Our Work Page/Kitchen Garden Initiative.webp";
import workInitiativeNursery from "./Images latest/Our Work Page/Nursary Development Programme.webp";
import workInitiativeTailoring from "./Images latest/Our Work Page/Tailoring & Embroidery Training Programme.webp";
import workInitiativeWomenEnt1 from "./Images latest/Our Work Page/Women Entrepreneurship Development Programme.webp";
import workInitiativeWomenEnt2 from "./Images latest/Our Work Page/Women Entrepreneurship Development Programme (2).webp";

import work1 from "./Images latest/Our Work Page/BAI00755.webp";
import work2 from "./Images latest/Our Work Page/BAI03242.webp";
import work3 from "./Images latest/Our Work Page/DSC_1807.webp";
import work4 from "./Images latest/Our Work Page/DSC_1810.webp";
import work5 from "./Images latest/Our Work Page/DSC_7245.webp";
import work6 from "./Images latest/Our Work Page/DSC_7256.webp";
import work7 from "./Images latest/Our Work Page/IMG-20220414-WA0066.webp";
import work8 from "./Images latest/Our Work Page/IMG-20220415-WA0000.webp";
import work9 from "./Images latest/Our Work Page/IMG-20250224-WA0007.webp";
import work10 from "./Images latest/Our Work Page/IMG20260608110642.webp";
import work11 from "./Images latest/Our Work Page/IMG20260608110740.webp";
import work12 from "./Images latest/Our Work Page/IMG20260608111147.webp";
import work13 from "./Images latest/Our Work Page/IMG20260608155650.webp";
import work14 from "./Images latest/Our Work Page/IMG20260608160009.webp";
import work15 from "./Images latest/Our Work Page/IMG20260608162829.webp";
import work16 from "./Images latest/Our Work Page/IMG20260608162854.webp";
import work17 from "./Images latest/Our Work Page/IMG_20260608_111132137_HDR.webp";
import work18 from "./Images latest/Our Work Page/VKP_8402.webp";
import work19 from "./Images latest/Our Work Page/VKP_8461.webp";
import work20 from "./Images latest/Our Work Page/VKP_8473.webp";
import work21 from "./Images latest/Our Work Page/WhatsApp Image 2025-04-12 at 2.39.10 PM.webp";
import work22 from "./Images latest/Our Work Page/WhatsApp Image 2026-01-06 at 7.51.59 AM (1).webp";
import work23 from "./Images latest/Our Work Page/WhatsApp Image 2026-01-06 at 7.51.59 AM (2).webp";
import work24 from "./Images latest/Our Work Page/WhatsApp Image 2026-01-06 at 7.51.59 AM.webp";
import work25 from "./Images latest/Our Work Page/WhatsApp Image 2026-03-12 at 7.09.00 PM (1).webp";
import work26 from "./Images latest/Our Work Page/WhatsApp Image 2026-03-12 at 7.09.00 PM (2).webp";
import work27 from "./Images latest/Our Work Page/WhatsApp Image 2026-03-12 at 7.09.00 PM.webp";
import work28 from "./Images latest/Our Work Page/WhatsApp Image 2026-03-12 at 7.09.01 PM.webp";
import work29 from "./Images latest/Our Work Page/WhatsApp Image 2026-04-08 at 6.03.06 PM (1).webp";
import work30 from "./Images latest/Our Work Page/WhatsApp Image 2026-04-08 at 6.21.32 PM.webp";
import work31 from "./Images latest/Our Work Page/WhatsApp Image 2026-04-16 at 6.14.57 PM (1).webp";
import work32 from "./Images latest/Our Work Page/WhatsApp Image 2026-04-16 at 6.14.58 PM (1).webp";
import work33 from "./Images latest/Our Work Page/WhatsApp Image 2026-04-16 at 6.14.58 PM.webp";
import work34 from "./Images latest/Our Work Page/WhatsApp Image 2026-04-16 at 6.15.44 PM.webp";
import work35 from "./Images latest/Our Work Page/WhatsApp Image 2026-08-14 at 12.36.47 PM (1).webp";
import work36 from "./Images latest/Our Work Page/WhatsApp Image 2026-08-14 at 8.03.14 PM (1).webp";
import work37 from "./Images latest/Our Work Page/WhatsApp Image 2026-08-14 at 8.03.14 PM.webp";
import work38 from "./Images latest/Our Work Page/WhatsApp Image 2026-10-05 at 7.09.25 PM (1).webp";
import work39 from "./Images latest/Our Work Page/WhatsApp Image 2026-10-05 at 7.09.25 PM.webp";
import work40 from "./Images latest/Our Work Page/WhatsApp Image 2026-10-05 at 7.09.26 PM.webp";
import work41 from "./Images latest/Our Work Page/WhatsApp Image 2026-10-05 at 7.09.27 PM.webp";

// Export Contact Us Image
export const contactUsImages = {
  header: contactHeaderImg,
  alt: "SOIL Foundation Field Operations & Community Center in Western Ghats",
};

// Export individual Home Page raw images
export {
  home1,
  home2,
  home3,
  home4,
  home5,
  home6,
  home7,
  home8,
};

// Export Home Page Images (8 items)
export const homePageClientImages = [
  {
    id: "home-c1",
    img: home1,
    title: "Community Assembly & Grama Samvaad",
    type: "Field Engagement",
    category: "Community",
    desc: "Grassroots dialogue with village elders and families discussing local community development priorities.",
  },
  {
    id: "home-c2",
    img: home2,
    title: "Green School Initiative: Nature Field Immersion",
    type: "Ecological Workshop",
    category: "Ecology",
    desc: "Hands-on ecological exploration and outdoor biodiversity awareness for rural school students.",
  },
  {
    id: "home-c3",
    img: home3,
    title: "Flora Documentation & Biodiversity Walk",
    type: "Western Ghats Action",
    category: "Ecology",
    desc: "Guiding students and volunteers in identifying native tree species and medicinal shrubs.",
  },
  {
    id: "home-c4",
    img: home4,
    title: "Adolescent Girls' Health & Menstrual Hygiene Session",
    type: "Health & Dignity",
    category: "Women",
    desc: "Interactive classroom orientation delivering essential menstrual health literacy to high school students.",
  },
  {
    id: "home-c5",
    img: home5,
    title: "Empowering Rural Students with Health Dignity",
    type: "Youth Well-being",
    category: "Women",
    desc: "Creating a safe, stigma-free learning space for young girls to understand hygienic healthcare practices.",
  },
  {
    id: "home-c6",
    img: home6,
    title: "Green School Initiative: Campus Afforestation",
    type: "Environmental Education",
    category: "Ecology",
    desc: "Engaging rural schoolchildren in campus tree plantation and environmental stewardship.",
  },
  {
    id: "home-c7",
    img: home7,
    title: "Grama Panchayat Leadership & Digital Platform Showcase",
    type: "Digital Governance",
    category: "Governance",
    desc: "Hebbalaguppe Gram Panchayat President M. Guruprasad demonstrating the digital governance and community services platform in collaboration with SOIL Foundation.",
  },
  {
    id: "home-c8",
    img: home8,
    title: "Sarpanch Samvad Mobile Governance Interface",
    type: "Civic Technology",
    category: "Governance",
    desc: "Digital mobile platform empowering elected Panchayat leaders with knowledge exchange, scheme tracking, and village networking.",
  },
];

// Export About Us Page Images (8 items)
export const aboutUsClientImages = [
  {
    id: "about-c1",
    img: about1,
    title: "Grassroots Dialogue & Collective Decision Making",
    caption: "Engaging village stakeholders in participatory rural appraisals and village action plans.",
    category: "Mobilization",
  },
  {
    id: "about-c2",
    img: about2,
    title: "Green School Initiative Campus Stewardship",
    caption: "Fostering environmental leadership and conservation ethics among rural students.",
    category: "Conservation",
  },
  {
    id: "about-c3",
    img: about3,
    title: "Eco-Education Mentorship in Village Schools",
    caption: "Development specialists and educators conducting nature-based learning in Karnataka schools.",
    category: "Education",
  },
  {
    id: "about-c4",
    img: about4,
    title: "Interactive School Classroom & Creative Learning",
    caption: "Strengthening rural school foundation with engaging, participatory classroom sessions.",
    category: "Education",
  },
  {
    id: "about-c5",
    img: about5,
    title: "Biodiversity & Nature Conservation Workshop",
    caption: "Nurturing ecological sensitivity and hands-on environmental values in students.",
    category: "Youth Action",
  },
  {
    id: "about-c6",
    img: about6,
    title: "Youth Environmental Field Expedition",
    caption: "Building the next generation of eco-stewards through experiential outdoor learning.",
    category: "Youth",
  },
  {
    id: "about-c7",
    img: about7,
    title: "Menstrual Hygiene Management (MHM) Awareness Program",
    caption: "Health workers and educators conducting menstrual hygiene awareness and sanitary pad distribution for adolescent girls.",
    category: "Health & Hygiene",
  },
  {
    id: "about-c8",
    img: about8,
    title: "Women Entrepreneurs Financial & Digital Literacy Cohort",
    caption: "Equipping women entrepreneurs with essential digital banking, UPI workflows, and business numeracy skills.",
    category: "Empowerment",
  },
];

// Export Our Work Page Initiative Images (Direct mapping)
export const ourWorkInitiativeImages = {
  kitchenGarden: workInitiativeKitchen,
  nurseryDevelopment: workInitiativeNursery,
  tailoringEmbroidery: workInitiativeTailoring,
  womenEntrepreneurship1: workInitiativeWomenEnt1,
  womenEntrepreneurship2: workInitiativeWomenEnt2,
};

// Export All 46 Images for Our Work Gallery with Domain Classification
export const ourWorkGalleryImages = [
  // 5 Specific Initiatives
  {
    id: "work-spec-1",
    img: workInitiativeKitchen,
    title: "Kitchen Garden Initiative",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Distribution of home vegetable kits and organic guidance to enhance nutritional self-reliance across rural households.",
  },
  {
    id: "work-spec-2",
    img: workInitiativeNursery,
    title: "Nursery Development Programme",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Nature-based livelihoods engaging women SHGs in raising native medicinal and forest sapling nurseries.",
  },
  {
    id: "work-spec-3",
    img: workInitiativeTailoring,
    title: "Tailoring & Embroidery Training Programme",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Vocational garment construction, stitching, and embroidery training supported by Bharat Cares and Vastu Housing Finance.",
  },
  {
    id: "work-spec-4",
    img: workInitiativeWomenEnt1,
    title: "Women Entrepreneurship Development (Cohort 1)",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Incubating rural women entrepreneurs through enterprise training, mentorship, and business start-up guidance.",
  },
  {
    id: "work-spec-5",
    img: workInitiativeWomenEnt2,
    title: "Women Entrepreneurship Development (Cohort 2)",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Showcasing established micro-enterprises including stationery, xerox, crafts, and retail services.",
  },

  // 41 Field Photographs
  {
    id: "work-p1",
    img: work1,
    title: "Participatory Village Assembly & Community Dialogue",
    category: "tribal",
    categoryLabel: "Community Mobilization",
    desc: "Grassroots gathering of rural families and women collectives discussing local welfare priorities.",
  },
  {
    id: "work-p2",
    img: work2,
    title: "Stakeholder Consensus & Grama Samvaad",
    category: "tribal",
    categoryLabel: "Community Mobilization",
    desc: "Deliberation with community elders and self-help group leaders on sustainable development plans.",
  },
  {
    id: "work-p3",
    img: work3,
    title: "Green School Native Tree Plantation",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Schoolchildren and teachers planting native tree varieties on school grounds to foster green campuses.",
  },
  {
    id: "work-p4",
    img: work4,
    title: "Hands-on Ecology & Soil Care Demonstration",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Demonstrating soil health conservation and organic composting practices to rural students.",
  },
  {
    id: "work-p5",
    img: work5,
    title: "Adolescent Menstrual Health & Hygiene Orientation",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Classroom workshop educating adolescent girls on menstrual health, personal hygiene, and destigmatization.",
  },
  {
    id: "work-p6",
    img: work6,
    title: "Sanitary Napkin Kit Distribution in High Schools",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Distributing free sanitary kits and hygienic care materials to high school students in Periyapatna taluk.",
  },
  {
    id: "work-p7",
    img: work7,
    title: "Rural Women Collective Leadership & Orientation",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Community training session building organizational leadership and mutual support for village women groups.",
  },
  {
    id: "work-p8",
    img: work8,
    title: "Women SHG Skill Development & Capacity Building",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Capacity-building training program empowering self-help group members with collective entrepreneurship skills.",
  },
  {
    id: "work-p9",
    img: work9,
    title: "SHG Microfinance & Savings Ledger Review",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Auditing community microfinance records and transparent passbook accounting for rural collectives.",
  },
  {
    id: "work-p10",
    img: work10,
    title: "Green School Initiative Campus Welcome",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Launching environmental eco-clubs and campus biodiversity initiatives in government schools.",
  },
  {
    id: "work-p11",
    img: work11,
    title: "Student Eco-Club Assembly & Briefing",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Orientation session preparing students for campus greening and waste segregation activities.",
  },
  {
    id: "work-p12",
    img: work12,
    title: "School Tree Stewardship & Biodiversity Pledge",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Students pledging commitment to nurture school trees and champion local environmental conservation.",
  },
  {
    id: "work-p13",
    img: work13,
    title: "Interactive Environmental Values Workshop",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Interactive classroom module teaching water conservation and biodiversity protection in Western Ghats.",
  },
  {
    id: "work-p14",
    img: work14,
    title: "Participatory Classroom Environmental Activities",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Encouraging collaborative problem-solving and environmental awareness among rural students.",
  },
  {
    id: "work-p15",
    img: work15,
    title: "Eco-Art & Biodiversity Drawing Presentations",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Students presenting artwork depicting native wildlife, forest trees, and local water bodies.",
  },
  {
    id: "work-p16",
    img: work16,
    title: "Environmental Leadership Badge Recognition",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Recognizing student eco-champions for their leadership in school greening projects.",
  },
  {
    id: "work-p17",
    img: work17,
    title: "Green School Initiative Community Launch",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Collaborative launch of the Green School initiative with teachers, school development committees, and students.",
  },
  {
    id: "work-p18",
    img: work18,
    title: "Classroom Environmental Science Workshop",
    category: "education",
    categoryLabel: "Green School Initiative",
    desc: "Bridging textbook environmental science with real-world conservation practices in rural schools.",
  },
  {
    id: "work-p19",
    img: work19,
    title: "Western Ghats Ecological Nature Expedition",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Guiding rural youth on mountain trails to observe watershed ecosystems and endemic vegetation.",
  },
  {
    id: "work-p20",
    img: work20,
    title: "Youth Catchment & Forest Exploration",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Experiential learning helping children understand forest ecology and river catchment zones.",
  },
  {
    id: "work-p21",
    img: work21,
    title: "Women Entrepreneurship Development Program",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Comprehensive enterprise incubation program equipping rural women with business planning skills.",
  },
  {
    id: "work-p22",
    img: work22,
    title: "Media Coverage: Rural Development & Health Drives",
    category: "women",
    categoryLabel: "Media Impact",
    desc: "Regional newspaper feature highlighting SOIL Foundation's grassroots health and education programs.",
  },
  {
    id: "work-p23",
    img: work23,
    title: "Press Coverage: Adolescent Menstrual Hygiene Awareness",
    category: "women",
    categoryLabel: "Media Impact",
    desc: "Newspaper report on SOIL Foundation's menstrual hygiene management session and sanitary pad distribution in Doddabelalu.",
  },
  {
    id: "work-p24",
    img: work24,
    title: "Press Report: High School Adolescent Health Linkages",
    category: "women",
    categoryLabel: "Media Impact",
    desc: "Press coverage documenting the collaborative healthcare program conducted with taluk health authorities.",
  },
  {
    id: "work-p25",
    img: work25,
    title: "Adolescent Girls' Menstrual Health Orientation",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Interactive awareness session providing adolescent girls with scientific guidance on menstrual care.",
  },
  {
    id: "work-p26",
    img: work26,
    title: "Free Sanitary Kit Distribution Drive",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Equipping high school girls with essential sanitary supplies to prevent school absenteeism during cycles.",
  },
  {
    id: "work-p27",
    img: work27,
    title: "Healthcare Staff & School Community Collaboration",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Primary health centre nurses and SOIL Foundation coordinators leading community health education.",
  },
  {
    id: "work-p28",
    img: work28,
    title: "Youth Dignity & Hygiene Awareness Milestone",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Students, teachers, and field teams celebrating the successful completion of the health awareness drive.",
  },
  {
    id: "work-p29",
    img: work29,
    title: "Financial & Digital Literacy for Women Entrepreneurs",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Hands-on training in digital banking, UPI payments, and financial management for women enterprise owners.",
  },
  {
    id: "work-p30",
    img: work30,
    title: "Women Entrepreneurs Digital Banking Workshop",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Empowering rural women with safe digital payment workflows and commercial bookkeeping tools.",
  },
  {
    id: "work-p31",
    img: work31,
    title: "Gram Panchayat Digital Governance Orientation",
    category: "education",
    categoryLabel: "Panchayat Leadership",
    desc: "Consultative meeting introducing elected village representatives to digital administration platforms.",
  },
  {
    id: "work-p32",
    img: work32,
    title: "Panchayat App Deployment & Field Onboarding",
    category: "education",
    categoryLabel: "Panchayat Leadership",
    desc: "Guiding Gram Panchayat officials on utilizing mobile applications for citizen outreach and transparent records.",
  },
  {
    id: "work-p33",
    img: work33,
    title: "Village Sarpanch Samvad Interactive Demo",
    category: "education",
    categoryLabel: "Panchayat Leadership",
    desc: "Demonstrating peer-to-peer knowledge sharing and scheme information through the Sarpanch Samvad network.",
  },
  {
    id: "work-p34",
    img: work34,
    title: "Sarpanch Samvad Mobile App Onboarding Program",
    category: "education",
    categoryLabel: "Panchayat Leadership",
    desc: "Statewide partnership with ISRA and QCI sensitizing Gram Panchayat presidents on digital governance.",
  },
  {
    id: "work-p35",
    img: work35,
    title: "Women Entrepreneurship Cohort Graduation",
    category: "women",
    categoryLabel: "Women Empowerment",
    desc: "Graduation and certificate distribution for women completing micro-enterprise incubation training.",
  },
  {
    id: "work-p36",
    img: work36,
    title: "Press Feature: Women Micro-Enterprise Success",
    category: "women",
    categoryLabel: "Media Impact",
    desc: "Media report covering the launch of women-led small businesses and vocational cooperatives in Mysore district.",
  },
  {
    id: "work-p37",
    img: work37,
    title: "Media Feature: Grassroots Livelihood Expansion",
    category: "women",
    categoryLabel: "Media Impact",
    desc: "Newspaper feature recognizing community development initiatives spearheaded by SOIL Foundation.",
  },
  {
    id: "work-p38",
    img: work38,
    title: "Green School Campus Native Planting",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Students and teachers preparing pits and planting indigenous shade trees in rural school courtyards.",
  },
  {
    id: "work-p39",
    img: work39,
    title: "Green School Environmental Stewardship Cohort",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Empowering rural schoolchildren with hands-on responsibilities for campus water management and plant care.",
  },
  {
    id: "work-p40",
    img: work40,
    title: "Green School Initiative Collaborative Session",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Teachers, students, and SOIL Foundation team collaborating on eco-club curriculum and biodiversity tracking.",
  },
  {
    id: "work-p41",
    img: work41,
    title: "Eco-Club Afforestation & Tree Adoption Campaign",
    category: "ecology",
    categoryLabel: "Ecological Conservation",
    desc: "Equipping young climate stewards to adopt trees and champion ecological resilience in their home villages.",
  },
];
